import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";

Vue.use(Vuex);

// Load store modules dynamically.
import app from "./modules/app.js";
import auth from "./modules/auth.js";
import cart from "./modules/cart.js";
import checkout from "./modules/checkout.js";
import companies from "./modules/companies.js";
import customer from "./modules/customer.js";
import delivery from "./modules/delivery.js";
import discovery from "./modules/discovery.js";
import guest from "./modules/guest.js";
import lang from "./modules/lang.js";
import loading from "./modules/loading.js";
import menus from "./modules/menus.js";
import orders from "./modules/orders.js";
import printer from "./modules/printer.js";
import settings from "./modules/settings.js";
import sound from "./modules/sound.js";
import storeInfo from "./modules/storeInfo.js";

const modules = {
  app: app.default || app,
  auth: auth.default || auth,
  cart: cart.default || cart,
  checkout: checkout.default || checkout,
  companies: companies.default || companies,
  customer: customer.default || customer,
  delivery: delivery.default || delivery,
  discovery: discovery.default || discovery,
  guest: guest.default || guest,
  lang: lang.default || lang,
  loading: loading.default || loading,
  menus: menus.default || menus,
  orders: orders.default || orders,
  printer: printer.default || printer,
  settings: settings.default || settings,
  sound: sound.default || sound,
  storeInfo: storeInfo.default || storeInfo,
};

export default new Vuex.Store({
  modules,
  getters,
});
